"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const R = __importStar(require("ramda"));
const react_final_form_arrays_1 = require("react-final-form-arrays");
const utils_1 = require("@8base/utils");
const FormContext_1 = require("./FormContext");
const utils_2 = require("./utils");
/**
 * `FieldArray` wrapper based on `FieldArray` from the [`react-final-form-arrays`](https://github.com/final-form/react-final-form-arrays). It accepts [`FieldArrayProps`](https://github.com/final-form/react-final-form-arrays#fieldarrayprops) props.
 */
const FieldArray = (props) => {
    const { tableSchema } = react_1.useContext(FormContext_1.FormContext);
    if (tableSchema) {
        const fieldSchema = utils_1.tableSelectors.getFieldByName(tableSchema, utils_2.getFieldSchemaName(props.name));
        if (fieldSchema) {
            props = Object.assign({ fieldSchema, isEqual: props.isEqual || R.equals }, props);
        }
    }
    return react_1.default.createElement(react_final_form_arrays_1.FieldArray, Object.assign({}, props));
};
exports.FieldArray = FieldArray;
//# sourceMappingURL=FieldArray.js.map